module.exports = __webpack_public_path__ + "img/Speaker6.50abc212.webp";